import { Query } from '@apollo/client/react/components';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React from 'react';
import { REFERRALS } from '../../../helpers/graphql/contest';
import DashboardCard from '../DashboardCard';

const Referrals = () => {
  return (
    <>
      <Query query={REFERRALS}>
        {({ data }) => {
          let title = '';
          if (data && data.referrals && data.referrals.length > 0)
            title = `Your have referred ${data.referrals.length} user${
              data.referrals.length > 1 ? 's' : ''
            }`;
          else if (data && data.referrals && data.referrals.length === 0)
            title = "You haven't referred anyone yet";
          return (
            <DashboardCard
              titleSize="h5"
              title={title}
              content={
                <>
                  {(data && data.referrals && data.referrals.length > 0 && (
                    <div
                      style={{
                        overflowX: 'auto',
                        wordWrap: 'normal',
                        wordBreak: 'normal',
                      }}
                    >
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Username</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {data &&
                            data.referrals &&
                            data.referrals.length > 0 &&
                            data.referrals.map(c => (
                              <TableRow hover key={c}>
                                <TableCell>{c}</TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                    </div>
                  )) ||
                    (data && data.referrals && data.referrals.length === 0 && (
                      <Typography variant="body1">
                        Once your referrals join TravelFeed, they will show up
                        here.
                      </Typography>
                    )) ||
                    ''}
                </>
              }
            />
          );
        }}
      </Query>
    </>
  );
};

export default Referrals;
